export default __webpack_public_path__ + "static/media/Ballroll_00158.d1a7782b.png";